/**
 * Maps monolith emoji placeholders (rendered as PNG in twig)
 * to their Unicode emoji equivalents for display in creators chat.
 */
const EMOJI_MAP: Record<string, string> = {
  "{{emoji_hand}}": "👋"
};

const EMOJI_PATTERN = /\{\{emoji_\w+\}\}/g;

export const replaceEmojiPlaceholders = (content: string): string =>
  content.replace(EMOJI_PATTERN, (match) => EMOJI_MAP[match] ?? match);
